import { EventEmitter, Output, Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[phone]',
  host: {
    '(ngModelChange)': 'onInputChange($event)',
    '(keydown.backspace)': 'onInputChange($event.target.value, true)'
  }
})
export class PhoneMask {
  constructor(public model: NgControl) { }

  @Output() rawChange: EventEmitter<string> = new EventEmitter<string>();

  onInputChange(event, backspace) {
    // remove all mask characters (keep only numeric)
    let newVal = (event || '').replace(/\D/g, '');
    let rawValue = newVal;
    // special handling of backspace necessary otherwise
    // deleting of non-numeric characters is not recognized
    // this laves room for improvment for example if you delete in the
    // middle of the string
    // if (backspace) {
    //   newVal = newVal.substring(0, newVal.length - 1);
    // }
    // don't show braces for empty value
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 3) {
      newVal = newVal.replace(/(\d{0,3})/, '$1');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1-$2-$3');
    } else {
      newVal = newVal[0] !== '1' ? newVal.substring(0, 10) : newVal.substring(1);
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1-$2-$3');
    }
    // set the new value
    // this.model.valueAccessor.writeValue(newVal);
    this.model.control.setValue(newVal, { emitViewToModelChange: false })
    this.rawChange.emit(rawValue);
  }
}



// import { Directive, Output, EventEmitter } from "@angular/core";
// import { NgControl } from "@angular/forms";

// @Directive({
//   selector: '[formControlName][phone]',
//   host: {
//     '(ngModelChange)': 'onInputChange($event)'
//   }
// })
// export class PhoneMaskDirective {

//   @Output() rawChange:EventEmitter<string> = new EventEmitter<string>();

//   constructor(public model: NgControl) {}

//   onInputChange(value) {
//         var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
//         var y = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

//         this.model.valueAccessor.writeValue(y);
//         this.rawChange.emit(value); 
//   }
// }